module.exports = __webpack_public_path__ + "img/gift1.b322a14e.png";